import axios from "axios";

const FLASK_API_ADDRESS: string = "https://api.texttoqrcode.com";
const FLASK_LOCAL_ADDRESS: string = "http://10.0.0.72:5050"

const instance = axios.create({
  baseURL: FLASK_API_ADDRESS,
  headers: {
      'Content-Type': 'application/json',
  }
});

 export default instance;
